(function($) {
  // Site title
  $(function($){
    var $header = $('header.banner, .search-box');
    $(window).scroll(function(){
      if($('body').hasClass('menu-open')){
        $header.css("left", '');
      } else {
        $header.css("left", -$(window).scrollLeft());
      }
      // if($(window).scrollTop() > 80) {
      //   $header.addClass('fixed');
      // } else {
      //   $header.removeClass('fixed');
      // }
    });
  });
})(jQuery);